// src/components/PortalHome.js

import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import supabase from '../../../supabaseClient';
import {
  BeakerIcon,
  VideoCameraIcon,
  CogIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/solid';

const PortalHome = () => {
	const [propertyUUID, setPropertyUUID] = useState(null);
	const location = useLocation();

	// Extract property_uuid from the URL with validation
	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const uuid = queryParams.get('property_uuid');

		if (uuid) {
		setPropertyUUID(uuid);
		console.log('Property UUID:', uuid);
		} else {
		console.warn('Invalid or missing property_uuid in the URL');
		}
	}, [location.search]);
	
	return (
		<div className="p-8">
			<h2 className="text-3xl font-bold mb-6">View report</h2>
			
			<div style={{textAlign:'center'}}>
				<div style={{padding:10, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
					<iframe
						id={"reportFrame"}
						height={"1123px"}
						width={"815px"}
						title={"Report editor"}
						style={{ display: "block", margin: "10 auto" }}
						src={`${window.location.origin}/report?property_uuid=${propertyUUID}`}
					/>
					
				</div>

			</div>

		</div>
	);
};

export default PortalHome;
